var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 871,
    height: 1745,
    viewBox: "0 0 871 1745",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2727_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.502 -95H828.002L876.502 1518.5C945.335 1558.17 742.5 1785.05 742.5 1474.5C742.5 1288.5 466.5 1164.33 504 1049.5C464.333 892.833 291.202 572.5 106.002 522.5C-79.1984 472.5 146.502 90 282.502 -95Z",
    fill: "#F2F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2727_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.034 507.243C153.434 544.589 66.3448 491.682 36 460.56C217.614 690.101 683.672 1393.83 894 1717V253.336C871.241 244.607 817.303 227.148 783.621 227.148C741.517 227.148 738.672 330.761 706.241 328.483C673.81 326.206 659.017 213.485 600.414 227.148C544.086 212.916 522.465 441.774 482.638 460.56C442.81 479.347 393.31 394.522 325.034 375.735C256.759 356.948 285.207 444.051 259.034 507.243Z",
    fill: "url(#paint0_linear_2727_1451)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2727_1451",
    x: 0.0999985,
    y: -130.9,
    width: 926.556,
    height: 1802.41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.95,
    result: "effect1_foregroundBlur_2727_1451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2727_1451",
    x: 8.4,
    y: 198.4,
    width: 913.2,
    height: 1546.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.8,
    result: "effect1_foregroundBlur_2727_1451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_1451",
    x1: 288,
    y1: 26,
    x2: 642.5,
    y2: 872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#ADC9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.3f801a3a34657b1e4464b6eba8288c35.svg";
export { ForwardRef as ReactComponent };